import moment from 'moment';
import momentTZ from 'moment-timezone';
// make sure needed locales are included in the bundle (en-us is default)
import 'moment/locale/en-gb';
const supportedLocales = ['en-gb', 'en-us'] as const;

const getPreferredLocale = (): (typeof supportedLocales)[number] => {
  const preferredLocale =
    navigator.language.toLowerCase() as (typeof supportedLocales)[number];
  return supportedLocales.includes(preferredLocale) ? preferredLocale : 'en-gb';
};

const init = (): void => {
  moment.locale(getPreferredLocale());
  momentTZ.locale(getPreferredLocale());
};

export const i18n = {
  init,
  getPreferredLocale,
};
